<template>
  <transition name="nav">
    <nav class="nav">
      <transition-group name="nav__breadcrumb" tag="ul">
        <li v-for="(node, index) in $route.matched" :key="node.path" v-if="node.meta.label" class="nav__breadcrumb">
          <router-link :to="getRouterLink(index, node)" active-class="nav__breadcrumb--active">{{ getNodeLabel(node) }}</router-link>
        </li>

      </transition-group>

      <menu-group
        class="nav__meta"
        :metaMenu="metaMenu">
      </menu-group>
    </nav>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { MenuGroup } from 'components/partials'
import L from 'services/Localization'
import File from 'services/File'

export default {
  name: 'navigation',
  components: { MenuGroup },
  watch: {
    emailAddress: function() {
      this.buildMenu()
    },
    tenant: function() {
      this.buildMenu()
    }
  },
  created() {
    this.buildMenu()
  },
  methods: {
    getRouterLink(index, node) {
      let link = {
        path: node.path
      }
      if (index !== 0) {
        link.path = undefined
        link.name = node.name
        link.params = this.$route.params
      }
      return link
    },
    getNodeLabel(node) {
      return node.meta.label
    },
    buildMenu() {
      let languageMenu = this.languageMenu()
      let accountMenu = this.accountMenu()
      this.$store.dispatch('set_menu', {
        menus: [languageMenu, accountMenu]
      })
    },
    accountMenu() {
      let menu = {
        label: this.emailAddress,
        figureClass: 'menu__figure',
        image: File.getPath(this.currentTenant.image),
        links: []
      }
      menu.links.push({
        label: L.localize('Settings_Breadcrumb_Account'),
        url: '/app/account'
      })
      menu.links.push({
        label: L.localize('Label_SignOut'),
        url: '/account/sign-out',
        bypassRouter: true
      })
      return menu
    },
    languageMenu() {
      let menu = {
        label: this.currentLanguage,
        figureClass: 'icon icon--language',
        links: []
      }
      let langs = this.languages
      Object.keys(this.languages).forEach(function(key) {
        if (langs.current !== key && langs.current !== langs[key]) {
          menu.links.push({
            'label': langs[key],
            'url': '/AbpLocalization/ChangeCulture?cultureName=' + key,
            'bypassRouter': true
          })
        }
      })
      return menu
    }
  },
  computed: {
    emailAddress() {
      return this.currentUser.emailAddress
    },
    currentLanguage() {
      return this.languages[this.languages.current]
    },
    tenant() {
      return this.currentTenant
    },
    ...mapGetters({
      languages: 'getLanguages',
      currentUser: 'getCurrentUser',
      currentTenant: 'getCurrentTenant'
    }),
    ...mapState({
      metaMenu: state => state.menu
    })
  }
}
</script>

<style lang="scss">
@import '~sass/tools';

.nav {
  transition: transform 250ms cb() 450ms;
  position: absolute;
  top: 0;
  right: 0;
  width: 85vw;
  height: 75px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: cc(bg);
  transform: translate3d(0, 0, 0);
  z-index: 1;

  &-enter {
    transform: translate3d(0, -100%, 0);
  }

  &__meta {
    display: flex;
    height: 100%;
  }

  &__breadcrumb {
    display: inline-block;
    margin-left: 2.5rem;
    text-transform: capitalize;
    @include nav-text;

    &:last-of-type {
      color: cc(primary);
    }

    &+& {
      position: relative;

      &::before,
      &::after {
        content: '';
        position: absolute;
        left: 0;
        width: 3px;
        height: .5rem;
        background-color: currentColor;
      }

      &::before {
        bottom: 50%;
        transform: translate3d(-1.25rem, 0, 0) rotate(-45deg);
        transform-origin: 100% 100%;
      }

      &::after {
        top: 50%;
        transform: translate3d(-1.25rem, 0, 0) rotate(45deg);
        transform-origin: 100% 0;
      }
    }

    &-enter-active {
      transition: all 250ms cb() 200ms;

      .nav__breadcrumb + & {
        &::before,
        &::after {
          transition: transform 250ms cb() 200ms;
        }
      }
    }

    &-leave-active {
      transition: all 200ms cb();

      .nav__breadcrumb + & {
        &::before,
        &::after {
          transition: transform 200ms cb();
        }
      }
    }

    &-enter,
    &-leave-to {
      transform: translate3d(-2rem, 0, 0);
      opacity: 0;

      .nav__breadcrumb + & {
        &::before {
          transform: translate3d(0, 0, 0) rotate(-45deg);
        }

        &::after {
          transform: translate3d(0, 0, 0) rotate(45deg);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?598c5f7e